<template>
  <div>
    <el-row v-if="activeName == 'depositPurchase'">
      <el-form :inline="true" class="demo-form-inline" :model="searchForm1" :ref="searchForm1"
        style="margin: 0">
        <el-col>
          <el-form-item label="选择日期：">
            <el-date-picker size="medium" v-model="searchForm1.START_END" type="daterange" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="是否含税：">
            <el-select size="medium" filterable v-model="searchForm1.TAX_SIGN" placeholder="请选择" :clearable="true">
              <el-option v-for="item in signLsit" :key="item.ID" :label="item.NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="副仓：" v-if="subWarehouseList && subWarehouseList.length > 0 ">
            <el-select v-model="searchForm1.SUB_WAREHOUSE" filterable placeholder="请选择副仓" clearable
                       style="width: 200px;">
              <el-option v-for="item in subWarehouseList" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="查询类型：">
            <el-select size="medium" filterable v-model="searchForm1.TYPE" placeholder="请选择" :clearable="true">
              <el-option v-for="item in typeLsit" :key="item.ID" :label="item.NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-button size="medium" type="primary" @click="search1">筛选</el-button>
          <el-button size="medium" type="primary" plain @click="exportTable">导出全版</el-button>
          <el-button size="medium" type="primary" plain @click="exportSimpleTable">导出简版</el-button>
        </el-col>
      </el-form>
    </el-row>
    <el-row v-if="activeName == 'totalDepositPurchase'">
      <el-col>
        <el-form :model="searchForm2" ref="searchForm2" :inline="true">
          <el-form-item label="日期范围：">
            <el-date-picker size="medium" v-model="searchForm2.DAY_INTERVAL" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="副仓：" v-if="subWarehouseList && subWarehouseList.length > 0 ">
            <el-select v-model="searchForm2.SUB_WAREHOUSE" filterable placeholder="请选择副仓" clearable
                       style="width: 200px;">
              <el-option v-for="item in subWarehouseList" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
           <el-form-item label="是否含税：">
            <el-select size="medium" filterable v-model="searchForm2.TAX_SIGN" placeholder="请选择" :clearable="true">
              <el-option v-for="item in signLsit" :key="item.ID" :label="item.NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" class="btn" @click="search2">筛选</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" plain class="btn" @click="exportData">导出</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" plain class="btn" @click="exportAverageData">导出均价</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px;">
      <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="进销存明细" name="depositPurchase">
          <V-DepositPurchase ref="depositPurchase" :search-form1="searchForm1" :current-page1="currentPage1"
            :table-data1="tableData1" v-if="flag">
          </V-DepositPurchase>
        </el-tab-pane>
        <el-tab-pane label="进销存汇总" name="totalDepositPurchase">
          <V-TotalDepositPurchase ref="totalDepositPurchase" :search-form2="searchForm2" :current-page2="currentPage2"
            v-if="flag"></V-TotalDepositPurchase>
        </el-tab-pane>
      </el-tabs>
</el-row>
  </div>
</template>
<script>
import VDepositPurchase from './depositPurchase';
import VTotalDepositPurchase from './totalDepositPurchase';

export default {
  data() {
    return {
      activeName: 'depositPurchase',
      tabActiveName: sessionStorage.getItem('InvoicingLedgerTabActiveName'),
      active: ['depositPurchase', 'totalDepositPurchase'],
      searchForm1: {
        PROJECT: '',
        SUPPLIER: '',
        TYPE: '1',
      },
      typeLsit: [{ NAME: '全部', ID: '0' }, { NAME: '自配', ID: '1' }, { NAME: '第三方', ID: '2' }],
      signLsit: [{ NAME: '含税', ID: '0' }, { NAME: '不含税', ID: '1' }],
      tableData1: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > (new Date()).getTime() - 3600 * 1000 * 24;
        },
      },

      subWarehouseList: JSON.parse(sessionStorage.getItem('subWarehouseList')),
      currentPage1: 1,
      flag: false,
      tempList: [],
      searchForm2: { MONTH: '' },
      customer: [],
      currentPage2: 1,
      totalFee: 0,
      totalCost: 0,
      realMoney: 0,
      tempObj: {},
    };
  },
  components: {
    VDepositPurchase,
    VTotalDepositPurchase,
  },
  created() {
    this.tabActive();
  },
  mounted() {
    this.handleClick();
  },
  computed: {
    // DEPOSIT_DATA_CONDITION() {
    //   return this.$store.state.DEPOSIT_DATA_CONDITION;
    // },
  },
  methods: {
    handleClick(tab, event) {
      sessionStorage.setItem('InvoicingLedgerTabActiveName', this.activeName);
      if (this.activeName == 'depositPurchase') {
        // if (this.DEPOSIT_DATA_CONDITION) {
        //   this.searchForm1 = this.DEPOSIT_DATA_CONDITION.CONDITION;
        //   this.currentPage1 = this.DEPOSIT_DATA_CONDITION.CURRENT_PAGE;
        //   this.tableData1 = this.DEPOSIT_DATA_CONDITION.DATA;
        // } else {
        //   this.currentPage = 1;
        // }
        this.flag = true;
        this.$nextTick(async () => {
          await this.$refs.depositPurchase.queryData();
        });
      } else {
        this.$set(this.searchForm2, 'DAY_INTERVAL', this.$store.state.TOTALDEPOSITPURCHASE_ALL.DAY_INTERVAL);
        this.flag = true;
        this.$nextTick(async () => {
          await this.$refs.totalDepositPurchase.search();
        });
      }
    },
    tabActive() {
      const flag = this.active.find((item) => {
        if (this.tabActiveName == item) {
          return true;
        }
      });
      if (flag) {
        this.activeName = this.tabActiveName;
      }
    },
    // **********进销存明细 开始**********
    // 筛选
    search1() {
      this.$refs.depositPurchase.search();
    },
    // 导出全版
    exportTable() {
      this.$refs.depositPurchase.exportTable();
    },
    // 导出简版
    exportSimpleTable() {
      this.$refs.depositPurchase.exportSimpleTable();
    },
    // **********进销存明细 结束**********
    // **********进销存汇总 开始**********
    // 筛选
    search2() {
      this.$refs.totalDepositPurchase.search();
    },
    // 导出
    exportData() {
      this.$refs.totalDepositPurchase.exportData();
    },
    // 导出均价
    exportAverageData() {
      this.$refs.totalDepositPurchase.exportAverageData();
    },
    // **********进销存汇总 结束**********
  },
};
</script>
<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/financeCenter/invoicingLedger.vue